import React, { useState, useEffect, useRef } from "react";
import { Calendar } from "@fullcalendar/core";
import listPlugin from "@fullcalendar/list";
import { useNavigate } from "react-router-dom";
import "../index.css";

const Index = ({
  arg: { month, setMonth, appointmentData, setAppointmentData },
}) => {
  const calendarRef = useRef(null);
  const [calendar, setCalendar] = useState(null);
  const [convertedArray, setConvertedArray] = useState([]);
  const navigate = useNavigate();

  const handleEventClick = (info) => {
    // Redirect to the work order page and pass data through state
    const eventId = info.event._def.title; // Assuming event id is available

    const eventDetails = appointmentData.find(
      (data) => data.tranId === eventId
    );
    if (eventDetails) {
      navigate("/work-order", {
        state: { tranId: eventId },
      });
    }
  };

  useEffect(() => {
    if (appointmentData?.length > 0) {
      const newConvertedArray = appointmentData.map((data) => ({
        start: new Date(data.date).toISOString(), // Convert date string to ISO 8601 format
        title: data.tranId,
        status: data.appstatus,
      }));
      setConvertedArray(newConvertedArray);
    }
  }, [appointmentData]);

  useEffect(() => {
    const calendarEl = calendarRef.current;
    const newCalendar = new Calendar(calendarEl, {
      plugins: [listPlugin],
      initialView: "listMonth",
      height: "auto",
      events: convertedArray,
      dateClick: handleDateClick,
      eventClick: handleEventClick,
      datesSet: handleDatesSet,
      timeFormat: "H:mm",
      eventRender: function (info) {
        const statusElement = document.createElement("div");
        statusElement.className = "event-status";
        statusElement.innerHTML = info.event.extendedProps.status;
        info.el.appendChild(statusElement);
      },
      buttonText: {
        today: "Current Month", // Change "today" button text to "Current Month"
      },
    });

    newCalendar.render();
    setCalendar(newCalendar);

    return () => {
      newCalendar.destroy();
    };
  }, []); // Empty dependency array, runs once on mount

  useEffect(() => {
    if (calendar) {
      calendar.getEventSources().forEach((eventSource) => {
        eventSource.remove();
      });
      calendar.addEventSource(convertedArray);
    }
  }, [convertedArray, calendar]);

  const handleDateClick = (info) => {
    const selectedMonth = info.date.getMonth() + 1;
    const selectedYear = info.date.getFullYear();
  };

  const handleDatesSet = (info) => {
    const currentStart = info.view.currentStart;
    const currentMonth = (currentStart.getMonth() + 1)
      .toString()
      .padStart(2, "0");
    const currentYear = currentStart.getFullYear();
    const formattedMonth = `${currentMonth}-${currentYear}`;
    setMonth(formattedMonth);
  };

  return (
    <div>
      <div ref={calendarRef}></div>
    </div>
  );
};

export default Index;

// const Index = ({
//   arg: { month, setMonth, appointmentData, setAppointmentData },
// }) => {
//   const calendarRef = useRef(null);
//   const [calendar, setCalendar] = useState(null);
//   const [convertedArray, setConvertedArray] = useState([]);

//   console.log("appointmentData===", appointmentData);
//   useEffect(() => {
//     if (appointmentData?.length > 0) {
//       const newConvertedArray = [];
//       for (const data of appointmentData) {
//         // const dateObject = new Date(data.date);
//         // const timeComponents = data.time.match(
//         //   /(\d+):(\d+):(\d+)(?: ([APMapm]+))?$/
//         // );

//         // if (dateObject && timeComponents) {
//         //   let [_, hours, minutes, seconds, period] = timeComponents;
//         //   hours = parseInt(hours, 10);
//         //   minutes = parseInt(minutes, 10);
//         //   seconds = parseInt(seconds, 10);

//         //   if (period) {
//         //     // Handle AM/PM format
//         //     if (period.toLowerCase() === "pm" && hours < 12) {
//         //       hours += 12;
//         //     } else if (period.toLowerCase() === "am" && hours === 12) {
//         //       hours = 0;
//         //     }
//         //   }

//         //   dateObject.setHours(hours, minutes, seconds);

//         //   const combinedDateTime = dateObject.toISOString();
//         const convertedObj = {
//           start: data.date,
//           title: data.tranId,
//           status: data.appstatus,
//         };
//         newConvertedArray.push(convertedObj);
//         // }
//       }
//       setConvertedArray(newConvertedArray);
//     }
//   }, [appointmentData]);

//   // console.log("convertedArray=>", convertedArray);

//   useEffect(() => {
//     const calendarEl = calendarRef.current;
//     const newCalendar = new Calendar(calendarEl, {
//       plugins: [listPlugin],
//       initialView: "listMonth",
//       height: "auto",
//       events: convertedArray,
//       dateClick: handleDateClick,
//       datesSet: handleDatesSet,
//       timeFormat: "H:mm",
//       eventRender: function (info) {
//         const statusElement = document.createElement("div");
//         statusElement.className = "event-status";
//         statusElement.innerHTML = info.event.extendedProps.status;
//         info.el.appendChild(statusElement);
//       },
//     });

//     // console.log("calendarEl", calendarEl);
//     newCalendar.render();
//     setCalendar(newCalendar);

//     // Cleanup when the component is unmounted
//     return () => {
//       newCalendar.destroy();
//     };
//   }, []); // Empty dependency array, runs once on mount

//   useEffect(() => {
//     if (calendar) {
//       calendar.getEventSources().forEach((eventSource) => {
//         eventSource.remove();
//       });
//       calendar.addEventSource(convertedArray);
//     }
//   }, [convertedArray, calendar]);

//   const handleDateClick = (info) => {
//     // Log the selected month and year when a date is clicked
//     const selectedMonth = info.date.getMonth() + 1;
//     const selectedYear = info.date.getFullYear();
//     // console.log(
//     //   `Selected Month: ${selectedMonth}, Selected Year: ${selectedYear}`
//     // );
//   };

//   const handleDatesSet = (info) => {
//     // Log the current month and year when the view changes
//     const currentStart = info.view.currentStart;
//     const currentMonth = (currentStart.getMonth() + 1)
//       .toString()
//       .padStart(2, "0");
//     const currentYear = currentStart.getFullYear();
//     const formattedMonth = `${currentMonth}-${currentYear}`;
//     setMonth(formattedMonth);
//     // console.log(`Current Month: ${formattedMonth}`);
//   };

//   // console.log("storeDate->", month);
//   return (
//     <div>
//       <div ref={calendarRef}></div>
//     </div>
//   );
// };

// export default Index;
